import React from 'react'

const ListIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ display: 'block' }}
    >
      <path d='M6.75 6H3.75V7.5H6.75V6Z' fill='#141414' />
      <path d='M9 7.5H20.25V6H9V7.5Z' fill='#141414' />
      <path d='M9 12.75H20.25V11.25H9V12.75Z' fill='#141414' />
      <path d='M20.25 18H9V16.5H20.25V18Z' fill='#141414' />
      <path d='M3.75 11.25H6.75V12.75H3.75V11.25Z' fill='#141414' />
      <path d='M6.75 16.5H3.75V18H6.75V16.5Z' fill='#141414' />
    </svg>
  )
}

export default ListIcon
